import { useEffect, useRef, useState } from "react";
import { DomEvent } from "leaflet";
import axios from "axios";
import CloseButton from "../buttons/CloseButton";
import classes from "./ArmyForm.module.scss";

const MultipleArmiesForm = ({ onClose, disabled }) => {
  const [armies, setArmies] = useState("");
  const [importError, setImportError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL || '/api';
  const token = window.localStorage.getItem("loggedBLUser");

  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      DomEvent.disableScrollPropagation(containerRef.current);
    }
  }, [containerRef]);

  const reload = () => {
    window.location.reload(false);
  };

  function handleAuthError(e) {
    if (e.response?.status === 401) {
      window.localStorage.removeItem("loggedBLUser");
      window.location.reload();
    } else {
      throw e;
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setImportError(null);

    const headers = { Authorization: `Bearer ${token}` };
    try {
      await axios.post(`${apiUrl}/armies/import`, { text: armies }, { headers });
      reload();
    } catch (e) {
      if (e.response?.status === 400) {
        setImportError(e.response.data);
        return;
      }

      handleAuthError(e);
    }
  };

  const getInvalidLineText = (invalidLine) => {
    if (typeof invalidLine === "object" && invalidLine !== null) {
      return invalidLine.text
        ? `${invalidLine.line}: ${invalidLine.text}`
        : `${invalidLine.line}`;
    }

    return `${invalidLine}`;
  };

  return (
    <div className={classes.form} ref={containerRef}>
      <CloseButton onClose={onClose} />

      <h5>Add Multiple Armies</h5>
      <form onSubmit={handleSubmit}>
        <div className={classes.group}>
          <label>
            <b>Provide a list of armies in this format:</b>
            <br />
            Army: Army Name1 General: player1
            <br />
            Army: Army Name2 General: player2
            <br />
            ...
            <br />
            <br />
            <b>Example:</b>
            <br />
            Army: Imperium Legionis Caesar General: Ganfi
            <br />
            Army: Imperium Legionis ⚔️ Aegis General: Faraona
            <br />
            ...
            <br />
            <br />

          </label>
          {importError && (
            <div className={classes.error}>
              <div>{importError.error}</div>
              {importError.invalidLines?.length > 0 && (
                <div>
                  Invalid line: {importError.invalidLines.map(getInvalidLineText).join(", ")}
                </div>
              )}
            </div>
          )}
          <textarea
            type="textarea"
            className={classes.largeTextarea}
            placeholder="Armies list"
            value={armies}
            onChange={(e) => {
              setArmies(e.target.value);
              setImportError(null);
            }}
            disabled={disabled}
          />
        </div>
        {!disabled && (
          <input type="submit" value="Submit" className={classes.btn} />
        )}
      </form>
    </div>
  );
};

export default MultipleArmiesForm;
